import ModalAttach from './ModalAttach'

export default ModalAttach
